import { Pipe, PipeTransform, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslationService } from 'src/app/service/api/translation.service';
import { TranslationRequest } from '../models/TranslationRequest';

@Pipe({
  name: 'translationClientCustomization',
  pure: false
})
export class TranslationClientCustomizationPipe implements PipeTransform, OnDestroy {
  private subscriptions = new Map<string, Subscription>();
  private translationCache = new Map<string, string>();

  constructor(
    private translationService: TranslationService,
    private cdr: ChangeDetectorRef
  ) {}

  transform(key: string, valueForClientSpecific: string = ''): string {
    if(sessionStorage.getItem('languagepreference') === null || sessionStorage.getItem('languagepreference') === 'en')
      {
        return valueForClientSpecific;
      }
    const cacheKey = `${key}`; //|${valueForClientSpecific}
    
    // If we already have a cached translation, return it
    if (this.translationCache.has(cacheKey)) {
      return this.translationCache.get(cacheKey);
    }

    // If we don't have a subscription for this key combination, create one
    if (!this.subscriptions.has(cacheKey)) {
      const subscription = this.translationService.getTranslationForKeyClientCustomization$(key, valueForClientSpecific).subscribe(
        (translatedValue) => {
          this.translationCache.set(cacheKey, translatedValue); //!translatedValue ? key : translatedValue
          this.cdr.markForCheck(); // Trigger change detection when translation is ready
        }
      );
      this.subscriptions.set(cacheKey, subscription);
    }

    // Try to get current translated value from service
    const currentTranslatedValue = this.translationService.getTranslationForKeyClientCustomization(key, valueForClientSpecific);
    if (currentTranslatedValue && currentTranslatedValue !== valueForClientSpecific) {
      this.translationCache.set(cacheKey, currentTranslatedValue);
      return currentTranslatedValue;
    }

    // Return client-specific value or key as fallback while waiting for translation
    return valueForClientSpecific || null;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
    this.subscriptions.clear();
    this.translationCache.clear();
  }
}